import React from "react";
import { Box } from "@mui/material";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const SkeletonIcon = RpSvgIcon as React.ElementType;

function CouponSkeleton() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        height: "100%",
        width: "100%",
      }}
    >
      {/* <img src="/img/skeleton_img.png" alt="" className="img-fluid" /> */}

      <SkeletonIcon
        style={{ width: "99%", height: "auto", display: "block" }}
        name="skeleton_img"
      />
    </Box>
  );
}

export default CouponSkeleton;
